// extracted by mini-css-extract-plugin
export default {"backGroundPicture":"catalogs_backGroundPicture__XSSvN","h3":"catalogs_h3__rmz0E"};